import { LightBulb } from 'common/icons';
import { Base } from 'common/layouts/Base';
import { Body } from 'component-library/components/typography/Body';
import { colors } from 'component-library/styles/colors';
import React, { FC } from 'react';
import styled from 'styled-components';

const TooltipWrapper = styled(Base)`
  background-color: ${colors.peach};
  border: 1px solid ${colors.white};
  padding: 25px;
  border-radius: 2px;
  margin-top: 32px;
`;

const StyledLightBulb = styled(LightBulb)``;

const StyledBody = styled(Body)`
  margin-top: 0 !important;
`;

interface ToolTipProps {
  content: string;
}

export const ToolTip: FC<ToolTipProps> = ({ content }) => (
  <TooltipWrapper spacing={3}>
    <StyledLightBulb width="34px" height="54px" stroke={colors.black} />
    <StyledBody variant={2}>{content}</StyledBody>
  </TooltipWrapper>
);
